import React, { useEffect, useRef } from 'react';

const Vision = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-x-0');
          entry.target.classList.remove('opacity-0', '-translate-x-9', 'translate-x-9');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.reveal-trigger');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="vision" className="py-28 bg-cogBlue/1 overflow-hidden font-sans text-cogInk">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        
        {/* Left Graphical Column */}
        <div className="reveal-trigger opacity-0 -translate-x-9 transition-all duration-700 ease-out relative">
          <div 
            className="rounded-2xl overflow-hidden shadow-xl aspect-[4/3] bg-cover bg-center"
            style={{ backgroundImage: `url('https://img.magnific.com/free-photo/two-smiling-female-colleagues-reading-news-tablet-cafe_1262-12589.jpg?semt=ais_hybrid&w=740&q=80')` }}
          ></div>

        </div>
        
        {/* Right Content Column */}
        <div className="reveal-trigger opacity-0 translate-x-9 transition-all duration-700 ease-out">
  <p className="tracking-[0.18em] text-[0.72rem] font-semibold uppercase text-cogCyan mb-3">
    Our Vision
  </p>

  <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight mb-6">
    Powering the future through reliable connectivity.
  </h2>

  <p className="text-cogInk/85 leading-relaxed mb-4">
    We envision becoming a globally recognized partner for wiring harness engineering and manufacturing, delivering innovative solutions that support the evolving needs of automotive, industrial, commercial, and energy sectors.
  </p>

  <p className="text-cogInk/85 leading-relaxed">
    By continuously advancing our engineering capabilities, manufacturing processes, and commitment to quality, we strive to build lasting partnerships and create dependable solutions that power tomorrow's technologies.
  </p>
</div>
      </div>
    </section>
  );
};

export default Vision;